import { Dispatch, SetStateAction } from "react";
import TextInput from "../../../components/form-fields/TextInput";
import { FormGroup } from "../../../components/forms";
import { ContractorType, Agents, Agent } from "../type";
import { NumberInput } from "../../../components/form-fields";
import LimitAlert from "./LimitAlert";

interface IProps {
  ele: Agent;
  keyIndex: number;
  originalInput: Agents;
  setState: Dispatch<SetStateAction<ContractorType>>;
  fieldToReplicate: keyof ContractorType;
  addBtnText: string;
  maxCount: number;
  validateField: any;
  limitMessage: string;
  t: any;
}

const getTitle = (suffixTitle: string, originalInput: Agents, keyIndex: number, prefixTitle: string) =>
  `${prefixTitle} ${originalInput.length === 1 ? "" : keyIndex + 1} ${suffixTitle} `;

const renderDeleteButton = (originalInput: Agents, deleteInput: () => void) => {
  if (originalInput.length > 1) {
    return (
      <button
        type="button"
        onClick={deleteInput}
        className="icon-middle icon-left-0 icon-5 icon-top-[1.25rem] icon-minus icon-red right text-red h-15 md:h-14 font-bold tex-xl md:w-auto self-end border-none px-8 py-2"
      >
        Delete
      </button>
    );
  }
  return null;
};

const renderAddButton = (
  originalInput: Agents,
  keyIndex: number,
  addInput: () => void,
  addBtnText: string,
  maxCount: number,
  limitMessage: string
) => {
  // add agent or broker button
  if (originalInput.length !== maxCount) {
    return (
      <button
        type={"button"}
        onClick={addInput}
        className="flex gap-4 items-center text-red h-15 md:h-14 font-bold tex-xl md:w-auto self-end px-8 py-2 border-2 border-red rounded-full"
      >
        <span className="icon-middle icon-left-0 icon-5 icon-plus icon-red"></span>
        <span>{addBtnText}</span>
      </button>
    );
  }
  return <LimitAlert message={limitMessage} />;
};

const MultiInputSpinButton: React.FC<IProps> = ({
  setState,
  keyIndex,
  ele,
  originalInput,
  fieldToReplicate,
  addBtnText,
  maxCount,
  validateField,
  limitMessage,
  t,
  ...props
}) => {
  const multiInputChange = (value: string, key: any) => {
    validateField(`agents.${keyIndex}.${key}`, value);
    setState(prevState => ({
      ...prevState,
      [fieldToReplicate]: (prevState[fieldToReplicate] as Agents).map((field, i) => (i === keyIndex ? { ...field, [key]: value } : field)),
    }));
  };

  const deleteInput = () =>
    setState(prevState => ({ ...prevState, [fieldToReplicate]: (prevState[fieldToReplicate] as Agents).filter((_, i) => i !== keyIndex) }));

  const addInput = () =>
    setState(prevState => ({
      ...prevState,
      [fieldToReplicate]: [
        ...(prevState[fieldToReplicate] as Agents),
        { agentCode: "", agentCommision: 15, basePremiumCP14: 0, basePremiumNCP26: 0 },
      ],
    }));

  return (
    <>
      <div className="flex flex-col">
        <FormGroup title={getTitle(t("code"), originalInput, keyIndex, t("agentCodePrefix"))} className="whitespace-nowrap">
          <TextInput
            aria-label={`agent-code-${keyIndex}`}
            value={ele.agentCode}
            label={t("agentCode")}
            onChange={e => multiInputChange(e.target.value, "agentCode")}
            disabled={false}
            {...(props as any)[keyIndex].agentCode}
          />
        </FormGroup>
        <FormGroup title={getTitle("Commission (%)", originalInput, keyIndex, t("agentCodePrefix"))} className="whitespace-nowrap">
          <NumberInput {...(props as any)[keyIndex].agentCommision} onValueChange={multiInputChange} value={ele.agentCommision} min={15} max={50} />
        </FormGroup>

        <FormGroup title={t("basePremiumCP14")} className="whitespace-nowrap">
          <NumberInput {...(props as any)[keyIndex].basePremiumCP14} min={0} max={500} onValueChange={multiInputChange} value={ele.basePremiumCP14} />
        </FormGroup>

        <FormGroup title={t("basePremiumNCP26")} className="whitespace-nowrap">
          <NumberInput
            {...(props as any)[keyIndex].basePremiumNCP26}
            onValueChange={multiInputChange}
            value={ele.basePremiumNCP26}
            min={0}
            max={500}
          />
        </FormGroup>

        {renderDeleteButton(originalInput, deleteInput)}
      </div>
      {originalInput.length - 1 === keyIndex && renderAddButton(originalInput, keyIndex, addInput, addBtnText, maxCount, limitMessage)}
    </>
  );
};

export default MultiInputSpinButton;
